import { PbmSevenComponent } from './pbm-seven/pbm-seven.component'
import { PbmFuncionalComponent } from './pbm-funcional/pbm-funcional.component'
import { PbmZicardComponent } from './pbm-zicard/pbm-zicard.component'

export class Pbm {
    constructor(pbmData) {
        switch(pbmData.codigoAdminConvenio) {
            case "45028":
                new PbmSevenComponent(pbmData);
                break;

            case "1334966":
                new PbmFuncionalComponent(pbmData);
                break;

            case "10604592":
                    new PbmZicardComponent(pbmData);
                    break;

            default:
                console.log("Nenhum pbm com este codigo", pbmData)
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm.js